// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"paymentconfirmation_submitButton__e5sxV"};